
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SummaryViewInstanceDialog extends SiteEntityDialog<SummaryViewInstanceRow, any> {
        protected getFormKey() { return SummaryViewInstanceForm.formKey; }
        protected getIdProperty() { return SummaryViewInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewInstanceRow.localTextPrefix; }
        protected getNameProperty() { return SummaryViewInstanceRow.nameProperty; }
        protected getService() { return SummaryViewInstanceService.baseUrl; }

        protected form = new SummaryViewInstanceForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.Account.instanceCode = this.entityId;
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.Account.set_readOnly(this.form.Account.get_readOnly() || this.isNew());
        }
    }
}